import { render } from "./DataAccessRequest.vue?vue&type=template&id=9600562c&scoped=true"
import script from "./DataAccessRequest.vue?vue&type=script&lang=js"
export * from "./DataAccessRequest.vue?vue&type=script&lang=js"

import "./DataAccessRequest.vue?vue&type=style&index=0&id=9600562c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9600562c"]])

export default __exports__